<template>
  <div>
    <Wheel ref="wheel"
      :gift="gift"
      :data="data"
      @done="done"
      :imgParams="logo"
      @click="spinTheWheel" />
  </div>
</template>

<script>

import { Wheel } from "vue3-fortune-wheel";
import 'vue3-fortune-wheel/style'

export default {
  name: 'App',
  components: {
    Wheel
  },
  data(){
    return {
      gift: 1,
      logo: {
        width: 110,
        height: 110,
        src:
          "/logo-2.svg",
      },
      data: [
        {
          id: 1,
          value: "Business training",
          bgColor: "#000",
          color: "#ffffff",
        },
        {
          id: 2,
          value: "Visit Pink Berry",
          bgColor: "#fff",
          color: "#000",
        },
        {
          id: 3,
          value: "Zhest center",
          bgColor: "#000",
          color: "#fff",
        },
        {
          id: 4,
          value: "The box",
          bgColor: "#fff",
          color: "#000",
        },
        {
          id: 5,
          value: "Lalunz",
          bgColor: "#000",
          color: "#fff",
        },
        {
          id: 6,
          value: "Theatre of the roo",
          bgColor: "#fff",
          color: "#000",
        },
        {
          id: 7,
          value: "4u",
          bgColor: "#000",
          color: "#fff",
        },
        {
          id: 8,
          value: "Palermo Home ",
          bgColor: "#fff",
          color: "#000",
        },
      
      ],
    }
  },
   methods: {
    done(params) {
      console.log(params);
    },
    spinTheWheel() {
      this.$refs.wheel.spin();
    },
  },
  created: function() {
    this.gift = Math.floor(Math.random() * this.data.length) + 1;
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
svg{
  font-size: 13px;
}
</style>
